// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyArgFrY1XGWDRYvqHBEKEMlZoYGKIGQplM",
  authDomain: "exoplanet-photography.firebaseapp.com",
  projectId: "exoplanet-photography",
  storageBucket: "exoplanet-photography.appspot.com",
  messagingSenderId: "774424519205",
  appId: "1:774424519205:web:ff4c0dd076b10ffa03d5cc"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
export default auth;